












import { Component, Vue, Model, Watch, Prop } from 'vue-property-decorator';

// import 'tinymce/themes/modern/theme';
// import Editor from '@tinymce/tinymce-vue';
// import 'tinymce/plugins/link'; // 链接插件

import 'tinymce/themes/modern/theme';
import Editor from '@tinymce/tinymce-vue';
@Component({
  components: { Editor },
})

/** 富文本组件 */
export default class C2HtmlEditor extends Vue {
  // 父组件传进来的html
  @Prop(String) value: any;
  @Prop(Boolean) disabled: boolean;

  editorContent = '';
  // 初始值
  content = '';
  editorInit: any = {
    language_url: `/static/zh_CN.js`,
    language: 'zh_CN',
    selector: 'textarea',
    skin_url: '/static/skins/lightgray',
    height: 400,
    branding: false,
    // width:600,
    font_formats:
      '宋体=宋体;黑体=黑体;仿宋=仿宋;楷体=楷体;隶书=隶书;幼圆=幼圆;Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
    plugins: [
      'advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr image imagetools insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount',
    ],
    toolbar: [
      'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
      'hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen',
    ],
  };
  editDisabled: boolean = false;

  mounted() {
    this.editorContent = this.value || '';
    this.editDisabled = this.disabled;
    // console.log('edithtml', this.editDisabled);
  }

  @Watch('value')
  valueChange(v: string) {
    this.editorContent = v;
  }

  /** 监听文本变化 */
  onChangeHandler(res: any, index: any, tag: any) {
    // console.log('onChangeHandler:', this.editorContent, ',args:', arguments);
    this.$emit('input', this.editorContent);
  }
}
